import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { filter } from 'rxjs/operators';
import { ErrorHandlingService } from '../../services/error-handling.service';
import { Authentication } from '../../services/authentication.service';
import { AccountService } from '../../services/account.service';
import { NotificationService } from '../../services/notification.service';
import { TitleService } from '../../services/title.service';

@Component({
  standalone: false,
  selector: 'app-email-verify',
  templateUrl: './email-verify.component.html',
  styleUrls: ['./email-verify.component.css'],
})
export class EmailVerifyComponent implements OnInit {
  isAdd = false;
  userName: string;
  notificationId: string;
  @ViewChild('resultModal') resultModal: any;
  closeResult = '';
  resultModalMessage = '';

  constructor(
    private authService: Authentication,
    private accountService: AccountService,
    private router: Router,
    private route: ActivatedRoute,
    private ngxLoader: NgxUiLoaderService,
    private modalService: NgbModal,
    private errorHandlingService: ErrorHandlingService,
    private titleService: TitleService,
    private notificationService: NotificationService,
  ) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.setTabTitle();
    });
    if (this.authService.isTokenValid()) {
      this.router.navigate(['automap']);
    }
  }
  setTabTitle() {
    this.titleService.setTitle(this.route.snapshot, this.router.routerState.snapshot);
  }
  resendVerificationEmail(): any {
    this.ngxLoader.start();
    this.accountService.resendVerificationEmail(this.userName.toLowerCase()).subscribe(
      (data) => {
        this.ngxLoader.stop();
        this.notificationService.showSuccess('Verification email resent to ' + this.userName);
      },
      (err) => {
        this.ngxLoader.stop();
        this.resultModalMessage = err.error.error;
        this.openModal();
        return this.errorHandlingService.handleError(err, err.url);
      },
    );
  }

  openModal() {
    this.modalService.open(this.resultModal, { ariaLabelledBy: 'modal-title' }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed `;
      },
    );
  }

  verifyEmail() {
    this.ngxLoader.start();
    this.notificationService.confirmAccountVerifyNotification(this.notificationId).subscribe(
      (data) => {
        this.ngxLoader.stop();
        if (data === null) {
          this.router.navigateByUrl('/login?verified=true');
        }
      },
      ({ error }) => {
        this.ngxLoader.stop();
        this.errorHandlingService.showError(error.message);
      },
    );
  }

  ngOnInit(): void {
    this.setTabTitle();
    this.userName = this.route.snapshot.queryParamMap.get('username');
    this.notificationId = this.route.snapshot.queryParamMap.get('notificationId');

    if (this.userName && this.notificationId) {
      this.verifyEmail();
    }
  }

  navigate() {
    window.location.href = 'https://www.terminologyhub.com';
  }
}
